import { defineComponent, onBeforeUnmount, onMounted, onUpdated, ref } from 'vue';
import omit from '../_util/omit';
import initDefaultProps from '../_util/props-util/initDefaultProps';
import Statistic, { statisticProps } from './Statistic';
import { formatCountdown as formatCD } from './utils';
const REFRESH_INTERVAL = 1000 / 30;
function getTime(value) {
    return new Date(value).getTime();
}
export const countdownProps = () => {
    return {
        ...statisticProps(),
        value: [Number, String, Object],
        format: String,
        onFinish: Function,
        onChange: Function,
    };
};
export default defineComponent({
    name: 'PfStatisticCountdown',
    props: initDefaultProps(countdownProps(), {
        format: 'HH:mm:ss',
    }),
    // emits: ['finish', 'change'],
    setup(props, { emit, slots }) {
        const countdownId = ref();
        const statistic = ref();
        const syncTimer = () => {
            const { value } = props;
            const timestamp = getTime(value);
            if (timestamp >= Date.now()) {
                startTimer();
            }
            else {
                stopTimer();
            }
        };
        const startTimer = () => {
            if (countdownId.value)
                return;
            const timestamp = getTime(props.value);
            countdownId.value = setInterval(() => {
                statistic.value.$forceUpdate();
                if (timestamp > Date.now()) {
                    emit('change', timestamp - Date.now());
                }
                syncTimer();
            }, REFRESH_INTERVAL);
        };
        const stopTimer = () => {
            const { value } = props;
            if (countdownId.value) {
                clearInterval(countdownId.value);
                countdownId.value = undefined;
                const timestamp = getTime(value);
                if (timestamp < Date.now()) {
                    emit('finish');
                }
            }
        };
        const formatCountdown = ({ value, config, }) => {
            const { format } = props;
            return formatCD(value, { ...config, format });
        };
        const valueRenderHtml = (node) => node;
        onMounted(() => {
            syncTimer();
        });
        onUpdated(() => {
            syncTimer();
        });
        onBeforeUnmount(() => {
            stopTimer();
        });
        return () => {
            const value = props.value;
            return (<Statistic ref={statistic} {...{
                ...omit(props, ['onFinish', 'onChange']),
                value,
                valueRender: valueRenderHtml,
                formatter: formatCountdown,
            }} v-slots={slots}/>);
        };
    },
});
